// What to show a person when the store says no. The store returns
// { ok: false, error, message }: `message` is the sentence for people,
// `error` a machine code ("not_found") — never shown as-is. An `error` that is
// already a sentence (older paths) is still fine to show.
const CODE = /^[a-z0-9_.-]+$/;

export function userMessage(r, fallback) {
  if (r?.message) return r.message;
  if (r?.error && !CODE.test(String(r.error))) return String(r.error);
  return fallback;
}
